import { createMuiTheme } from "@material-ui/core/styles";
import { pink } from "@material-ui/core/colors";
export const defaultTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#ffffff"
    },
    secondary: pink
  }
});
